import React from 'react'
import { Alert } from 'reactstrap'

const InformativeBanner = ({ sentences }) => {
  function countWords(sentence) {
    return sentence
      .replace(/(^\s*)|(\s*$)/gi, '')
      .replace(/[ ]{2,}/gi, ' ')
      .replace(/\n /, '\n')
      .split(' ')
      .filter((str) => str !== '')
      .length
  }

  function percentage(partial, total) {
    if (partial === 0 && total === 0) return 0;
    return Math.round((partial / total) * 100)
  }

  function color(percentage) {
    return (percentage > 45) ? 'warning' : 'secondary'
  }

  const totalRawWords = (sentences || []).reduce((memo, sentence) => {
    memo += countWords(sentence.content)
    return memo
  }, 0);
  const totalCopiedWords = (sentences || []).reduce((memo, sentence) => {
    if ((sentence.search || []).length !== 0) {
      memo += countWords(sentence.content)
    }
    return memo
  }, 0);

  return (
    <Alert color={color(percentage(totalCopiedWords, totalRawWords))}>
      <span className="font-weight-bold text-dark">
        {percentage(totalCopiedWords, totalRawWords)}
        % do conteúdo é copiado!
        {' ('}
        {totalCopiedWords}
        {'/'}
        {totalRawWords}
        {' palavras)'}
      </span>
    </Alert>
  )
}

export default InformativeBanner
